module.exports = __webpack_public_path__ + "img/mailbox.bedd80f9.svg";